/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { AbcConfigService } from '@barthauer/abc/core/configuration';
import { AbcIconComponent } from '@barthauer/abc/ui-components/abc-icon';
import { AbcDropDownBoxComponent } from '@barthauer/abc/ui-components/abc-drop-down-box';
import { AbcQrCodeViewerComponent } from '@barthauer/abc/ui-components/abc-qrcode-viewer';
import { _AbcSelectBoxComponent } from '@barthauer/abc/ui-components/abc-select-box';
import { AbcTextBoxComponent } from '@barthauer/abc/ui-components/abc-text-box';
import { DxLoadIndicatorModule } from 'devextreme-angular';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { FlexLayoutModule } from 'ngx-flexible-layout';
import { AuthenticationInterceptor } from './interceptor/interceptor';
import { LoginComponent } from './login/login.component';
import { ProfileSelectionComponent } from './profile-selection/profile-selection.component';
import { QrCodeScannerComponent } from './qr-code-scanner/qr-code-scanner.component';
import { RegisterComponent } from './register/register.component';
import { AuthConfigService } from './services/auth-config.service';
import { AuthenticationGuard } from './services/authentication.guard';
import { LoginSettingsService } from './services/login-settings.service';
import { ProfileSettingsService } from './services/profile-settings.service';
import { ProfileService } from './services/profile.service';
import { UserService } from './services/user.service';
import { WebApiEditorGuard } from './services/web-api-editor.guard';
import { TwoStepAuthComponent } from './two-step-auth/two-step-auth.component';
import { WebApiEditorComponent } from './webapi-editor/webapi-editor.component';
import { IsAdminGuard } from './services/isAdmin.guard';

@NgModule({
  declarations: [
    LoginComponent,
    RegisterComponent,
    ProfileSelectionComponent,
    WebApiEditorComponent,
    QrCodeScannerComponent,
    TwoStepAuthComponent,
  ],
  exports: [
    LoginComponent,
    MatToolbarModule,
    MatButtonModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    ProfileSelectionComponent,
    WebApiEditorComponent,
    RegisterComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MatGridListModule,
    MatToolbarModule,
    MatTooltipModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatIconModule,
    MatInputModule,
    MatDividerModule,
    MatListModule,
    MatProgressBarModule,
    MatSnackBarModule,
    MatCardModule,
    FlexLayoutModule,
    AbcTextBoxComponent,
    AbcDropDownBoxComponent,
    _AbcSelectBoxComponent,
    AbcQrCodeViewerComponent,
    DxLoadIndicatorModule,
    AbcIconComponent,
    DxiButtonModule,
  ],
  providers: [
    HttpClient,
    AuthenticationGuard,
    IsAdminGuard,
    UserService,
    ProfileService,
    AuthConfigService,
    LoginSettingsService,
    ProfileSettingsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      deps: [AbcConfigService, Router, LoginSettingsService, ProfileSettingsService, UserService],
      multi: true,
    },
    WebApiEditorGuard,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AbcCoreAuthenticationModule {}
